'use client'

import { useReportWebVitals } from 'next/web-vitals'

const VITALS_ENDPOINT = '/api/vitals'
const SUPPORTED = new Set(['LCP', 'INP', 'FCP', 'TTFB', 'CLS', 'FID'])

type Metric = Parameters<Parameters<typeof useReportWebVitals>[0]>[0]

// 콜백 ref가 변하면 Next.js가 중복 보고하므로 모듈 상수로 선언
const reportVital = (metric: Metric) => {
  if (!SUPPORTED.has(metric.name)) return

  const body = JSON.stringify({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
    navigationType: metric.navigationType,
  })

  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    navigator.sendBeacon(VITALS_ENDPOINT, body)
    return
  }

  fetch(VITALS_ENDPOINT, { body, method: 'POST', keepalive: true }).catch(() => {})
}

export const WebVitals = () => {
  useReportWebVitals(reportVital)
  return null
}
